import { PermissionsTable } from 'src/components/permissions/list/table';
import {
  Filter,
  useFilteredPermissions,
} from 'src/components/common/form/permissions/filter';
import { PermissionListFilterInput, User } from 'src/graphql/generated/graphql';
import { useTranslation } from 'react-i18next';
import { useTable } from 'src/hooks/use-table';
import { useMemo } from 'react';

type PermissionsAssignedProps = {
  user: Partial<User>;
};

export const PermissionsAssigned = ({ user }: PermissionsAssignedProps) => {
  const { t } = useTranslation();
  const permissions = user.permissionsExplained ?? [];

  const { filter, onFilterChange } = useTable<
    PermissionListFilterInput,
    Record<any, any>
  >();

  const data = useFilteredPermissions({
    permissions,
    filter,
  });

  return (
    <>
      <Filter onSubmit={onFilterChange} exclude={{ tagIds: true }} />
      <PermissionsTable
        title={t('manage-otps.details.permissions-assigned')}
        data={data}
        disabledFields={['isDisabled', 'tags', 'actions']}
        options={{
          count: data.length,
        }}
      />
    </>
  );
};
